// `plan.recorded` (#3800): a plan's group DAG was written, on the write's own
// transaction. Its own module beside `./maintenance-tenancy.ts`, which is at the
// file-size bound and only lists it. Rendered like `plan_group.merged` there: which
// plan, and how many groups this batch wrote (`output.groups`); the ids, repos and
// edges stay on the row.

import type { TerminalRenderContext, TerminalRendered } from '../../../wire/terminal';
import { num, str } from './maintenance-payload';

export function renderPlanRecorded(ctx: TerminalRenderContext): TerminalRendered | null {
  const planId = str(ctx.row.input, 'planId');
  const groups = num(ctx.row.output, 'groups');
  if (planId === null || groups === null) return null;
  return {
    line: { key: 'terminal.plan.recorded', params: { groups } },
    subject: { kind: 'plan', id: planId, label: planId },
    refs: { planId },
  };
}
